import {Box, Stack, styled} from '@mui/material';
import {AlertInfo, StyledGrid} from 'presentation/components';

const StyledRootGrid = styled(StyledGrid.Root)`
	padding: 0px 32px;
	margin-top: 16px;

	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 0px 16px;
	}
`;

const StyledGridItem = styled(StyledGrid.Item)`
	${({theme}) => theme.breakpoints.down('md')} {
		padding-top: 0px !important;
	}
	margin-top: 0px;
	gap: 24px;
`;

const StyledBoxAlertInfo = styled(Box)`
	margin-top: 32px;
	padding: 8px 0px;
`;

const StyledAlertTitle = styled(AlertInfo.Title)`
	margin-bottom: 20px;
`;

const StyledStack = styled(Stack)`
	gap: 24px;
`;

export {StyledRootGrid, StyledGridItem, StyledBoxAlertInfo, StyledAlertTitle, StyledStack};
